/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editInvestmentProjectActions, {
    editInvestmentProjectTypes,
} from '../../../redux/investmentProjects/editInvestmentProject'

import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* editInvestmentProjectSagas({ response }) {
    try {
        const res = yield Put(`project_investment/${response.id}`, response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    editInvestmentProjectActions.editInvestmentProjectSuccess(
                        res.data
                    )
                ),

                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
            yield put(goBack())
        } else {
            yield put(
                editInvestmentProjectActions.editInvestmentProjectFailure(res)
            )
        }
    } catch (error) {
        yield put(
            editInvestmentProjectActions.editInvestmentProjectFailure(error)
        )
    }
}

export function* editInvestmentProjectSaga() {
    yield takeLatest(
        editInvestmentProjectTypes.EDIT_INVESTMENT_PROJECT_REQUEST,
        editInvestmentProjectSagas
    )
}
